import { useState } from 'react';

export const useAcademicCalendarService = () => {
  const [selectedTab, setSelectedTab] = useState<string>();

  return {
    state: { selectedTab },
    methods: { setSelectedTab },
  };
};
